import React from 'react';
import { Text } from 'components/typography/Text';
import { formatCurrency } from 'utils/format';
import styles from './styles.module.scss';

export const TotalCost = ({ totalCost }) => (
  <div className={styles.totalCost}>
    <Text
      white
      size={18}
      className={styles.amountLabel}
      intl="amount"
    />

    <Text
      white
      size={18}
    >
      {formatCurrency(totalCost)} KR
    </Text>
  </div>
);
